import { gql } from '@apollo/client'

export interface ProductTaxCategoryResponse {
  productTaxCategory: {
    externalCode: string | null
  } | null
}

export interface ProductTaxCategoryVariables {
  productId: string
}

export const ProductTaxCategory = gql`
  query ProductTaxCategory($productId: ID!) {
    productTaxCategory(productId: $productId) {
      externalCode
    }
  }
`
